import http from 'src/services/httpService';
import ContentManager from '../content-manager';
import { Checkbox } from '../Form';
import handleError from 'src/utils/error-handler';
import Confirm from 'src/componentes/message-box/confirm';
import { formatTextToHtml } from 'src/utils/html';
import { capitalizeFirstLetter } from 'src/utils/string';

export async function acessarFrstClick(intl) {
  const urlFrst = 'https://hall.frstfalconi.cloud/home';

  try {
    const response = await http.get('Colaborador/ObterExibirAvisoFrst');
    const exibirMensagem = response.data;

    if (exibirMensagem) {
      ContentManager.addContent(
        <Confirm
          titleCapitalizeNone={true}
          textCapitalizeTitle={false}
          title={capitalizeFirstLetter(
            intl.formatMessage({ id: 'tudoProntoParaAvancar' })
          )}
          message={
            <div>
              <div>
                <div
                  dangerouslySetInnerHTML={{
                    __html: formatTextToHtml(
                      intl.formatMessage({
                        id: 'frstRedirectMessage',
                      })
                    ),
                  }}
                />
              </div>
              <div className="d-flex">
                <Checkbox id={`nao-visualizar-novamente-frst`} />
                <span>
                  {intl.formatMessage({
                    id: 'naoQueroVerEssaInformacaoNovamente',
                  })}
                </span>
              </div>
            </div>
          }
          handleConfirm={async () => {
            const naoMostrar = document.getElementById(
              'nao-visualizar-novamente-frst'
            ).checked;
            if (naoMostrar) {
              try {
                http.post('Colaborador/MarcarNaoExibirNovamenteAvisoFrst');
              } catch (err) {
                handleError(err);
              }
            }

            window.open(urlFrst, '_blank');
          }}
        />
      );
    } else {
      window.open(urlFrst, '_blank');
    }
  } catch (error) {
    handleError(error);
  }
}
